import React, { ReactNode, useState } from "react";
import { closePopup } from "../utils/popupUtilities";

interface ButtonProps {
  label: string | React.ReactNode;
  width: string;
  children?: ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  extraClasses?: string;
  lockMs?: number;
  disable?: boolean;
  submit?:boolean;
}

export default function Button({
  label,
  children,
  width,
  extraClasses = "",
  onClick,
  lockMs = 2000,
  disable,
  submit=false,
}: ButtonProps) {
  const [isDisabled, setIsDisabled] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isDisabled) return;
    if (disable) {
      setIsDisabled(true);
      setTimeout(() => setIsDisabled(false), lockMs);
    }
    onClick?.(e);
  };

  return (
    <button
    type={submit ? "submit":"button"}
    disabled={isDisabled}
    className={
      extraClasses +
      ` w-${width} dark:bg-ndblue rounded transition text-center disabled:opacity-50 disabled:cursor-not-allowed dark:hover:bg-ndblue ` +
      (isDisabled ? "hover:bg-ndblue dark:hover:bg-ndblue" : "")
    }
    onClick={handleClick}
    >
      {children}
      {label}
    </button>
  );
}
